
import DefaultTenant from './Default'

export default {
  ...DefaultTenant,
  "title": "Client B",
  "homepageBackgroundImg": "/homepage/ClientB.jpg",
  "callToAction": {
    "backgroundColor": "#4098D7",
  },
  "nomenclature": {
    "partition": {
      "singular": "Partition",
      "plural": "Partitions"
    }
  },
  "mapMultiselect": true,
  "mapClusters": true,
}
